import { css, SerializedStyles } from '@emotion/react';

export const STATIC_STYLES: SerializedStyles = css`
    opacity: 0;
    vertical-align: middle;

    // We only fade the image in if it was offscreen when the page loaded
    &[data-hidden-on-mount] {
        transition: opacity 500ms ease;
    }

    &[data-loaded] {
        opacity: 1;
    }
`;
